import { Component } from '@angular/core';
import { ApiUrlHelper } from '../../../../common/api-url-helper';
import { CommonService } from '../../../../services/common/common.service';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { StateService } from '../../../../services/common/claim-year.service';
import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { commonLabelConstants, ConnectedFormConstants } from '../../../../constants/label-constants';
import { SharedService } from '../../../../services/shared-service/shared.service';
import { Subject, takeUntil } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { ValidationService } from '../../../../services/common/validation-service';

@Component({
  selector: 'app-contractor-form',
  templateUrl: './connected-subcontractor-form.component.html',
  styleUrl: './connected-subcontractor-form.component.scss'
})

export class ContractorFormComponent {

  env : any = environment;
  projectList: any = [];
  companyId: any = 0
  claimYearId: any = 0;
  subContractorConnectedRNDForm!: FormGroup;
  detail: any = [];
  isLoading: boolean = false;
  projectProductTotals: number[] = [];
  onDestroy$: Subject<void> = new Subject();
  commonLabelConstants = commonLabelConstants;
  labelConstants = ConnectedFormConstants;
  isLocked: boolean = false;

  constructor(private readonly api: ApiUrlHelper,
    private readonly commonService: CommonService,
    private readonly sharedDataService: StateService,
    private readonly fb: FormBuilder,
    private readonly spinner: NgxSpinnerService,
    private readonly router : Router,
    private readonly sharedService: SharedService,
    private readonly validationService:ValidationService
  ) {
  }

  get subContractor(): FormArray {
    return this.subContractorConnectedRNDForm.get('subContractor') as FormArray
  }

  ngOnInit() {

    this.subContractorConnectedRNDForm = this.fb.group({
      subContractor: this.fb.array([])
    });
    this.sharedDataService.companyId$.subscribe((companyId) => {
      this.companyId = companyId;
    });
    this.sharedDataService.yearId$.pipe(takeUntil(this.onDestroy$)).subscribe((yearId) => {
      this.claimYearId = yearId ?? null;
      if (this.companyId && this.claimYearId) {
        this.resetForm();
        this.getProjectListCompanyWise(this.companyId, this.claimYearId)
      }
    });
  }

  resetForm(){
    this.subContractorConnectedRNDForm = this.fb.group({
      subContractor: this.fb.array([])
    });
  }

  createSubContractor(): FormGroup {
    return this.fb.group({
      subContractorId: [null],
      subContractorName: [{value: '', disabled: true}, Validators.required],
      subContractorJobRole: [{value: '', disabled: true}, Validators.required],
      rationaleForRNDEligibilityAssessment: [''],
      subContractorConnectedResourceId: [0],
      total : [0],
      totalForNonUK: [0],
      totalEligibilityAmount : [0],
      totalEligibilityAmountForNonUk : [0],
      projects: this.fb.array([])
    });
  }

  getProjectListCompanyWise(companyId: any, claimYearId: any) {
    this.spinner.show()
    let api = this.api.apiUrl.Project.GetProjectListWithOutPagination.replace('{companyId}', companyId).replace('{claimYearId}', claimYearId);
    this.commonService.doGet(api).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          this.projectList = response.data;
          this.getsubContractorDetail()
        }
        else {
          this.projectList = [];
        }
      },
      error: (error: any) => {
        console.log(error);
        this.spinner.hide();
      },
      complete: () => {
      },
    });
  }

  calculateSumProduct() {
    const projectCount = this.projectList.length;
    this.projectProductTotals = Array(projectCount).fill(0);

    this.subContractor.controls.forEach((contractorGroup: any) => {
      const total = contractorGroup.get('total')?.value || 0;
      const totalforNonUk = contractorGroup.get('totalForNonUK')?.value || 0;

      const projects = this.getProjectDetails(this.subContractor.controls.indexOf(contractorGroup));
      projects.controls.forEach((projectGroup: any, projectIndex: number) => {
        const rndEligibility = projectGroup.get('rndEligibility')?.value || 0;
        this.projectProductTotals[projectIndex] += ((total + totalforNonUk)* rndEligibility) / 100;
      });
    });
  }

  getsubContractorDetail() {
    this.isLoading = true;
    let obj = {
      companyId: this.companyId,
      claimYearId: this.claimYearId
    }
    let api = this.api.apiUrl.SubContractorConnectedResource.subContractorConnectedList;
    this.commonService.doPost(api, obj).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          this.detail = response.data;
          this.isLocked = ( this.detail[0]?.isLocked ?? false);
          this.isLoading = false;
          this.detail.forEach((item: any) => {
            const newSubContractor = this.createSubContractor();
            newSubContractor.patchValue({
              subContractorId: item.employeeId,
              subContractorName: item.subContractorName,
              subContractorJobRole: item.description,
              total : item.total,
              totalForNonUK: item.totalForNonUK,
              totalEligibilityAmount : item.totalEligibilityAmount,
              totalEligibilityAmountForNonUk : item.totalEligibilityAmountForNonUk,
              rationaleForRNDEligibilityAssessment: item.rationaleForRNDEligibilityAssessment,
              subContractorConnectedResourceId: item.subContractorConnectedResourceId
            });
            const subContractorDetailsArray = newSubContractor.get('projects') as FormArray;

            this.projectList.forEach((itemDetail: any) => {
              const newSubContractorDetail = this.createSubContractorDetailsArrayProjectDetail();
              newSubContractorDetail.patchValue({
                subContractorConnectedResourceId: item.projects.find((projectDetail: any) => projectDetail.projectId == itemDetail.projectId) ? item.projects.find((projectDetail: any) => projectDetail.projectId == itemDetail.projectId).subContractorConnectedResourceId : 0,
                SubContractorConnectedEligibilityId: item.projects.find((projectDetail: any) => projectDetail.projectId == itemDetail.projectId) ? item.projects.find((projectDetail: any) => projectDetail.projectId == itemDetail.projectId).subContractorConnectedId : 0,
                projectId: itemDetail.projectId,
                rndEligibility: item.projects.find((projectDetail: any) => projectDetail.projectId == itemDetail.projectId) ? (item.projects.find((projectDetail: any) => projectDetail.projectId == itemDetail.projectId).rndEligibility ?? 0) : '0'
              });
              subContractorDetailsArray.push(newSubContractorDetail);
            });
            this.subContractor.push(newSubContractor);
          })
          this.calculateSumProduct();
        }
        this.spinner.hide();
      },
      error: (error: any) => {
        this.isLoading = false;
        console.log(error);
        this.spinner.hide();
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  createSubContractorDetailsArrayProjectDetail() {
    return this.fb.group({
      subContractorConnectedResourceId: [null],
      SubContractorConnectedEligibilityId: [null],
      projectId: ['', Validators.required],
      rndEligibility: ['']
    });
  }

  getItemAtIndex(index: number): FormGroup {
    return this.subContractor.at(index) as FormGroup;
  }

  getProjectDetails(index: any) {
    return this.getItemAtIndex(index).get('projects') as FormArray;
  }

  goBack(): void {
    this.router.navigateByUrl('/dashboard');
  }

  getTotalValueOfSubContractor(index: any) {
    let total = 0;
    for (let i = 0; i < this.getProjectDetails(index).length; i++) {
      const detail = this.getProjectDetails(index).at(i).value;

      total += parseFloat(detail.rndEligibility ? detail.rndEligibility : 0)
    }
    return total;
  }

  getProjectTotal(projectIndex: number): number {
    let total = 0;
    this.subContractor.controls.forEach(contractorControl => {
      const projectsArray = contractorControl.get('projects') as FormArray;
      const rndEligibilityValue = projectsArray.at(projectIndex)?.get('rndEligibility')?.value;
      if (rndEligibilityValue) {
        total += parseFloat(rndEligibilityValue);
      }
    });
    return total;
  }

  getUkGrandTotal(): number {
    return this.subContractor.controls.reduce((grandTotal, contractorControl, index) => {
      return grandTotal + contractorControl.get('totalEligibilityAmount')?.value;
    }, 0);
  }

  getNonUKGrandTotal(): number {
    return this.subContractor.controls.reduce((grandTotal, contractorControl, index) => {
      return grandTotal + contractorControl.get('totalEligibilityAmountForNonUk')?.value;
    }, 0);
  }

  getCostTotal(): number {
    return this.subContractor.controls.reduce((grandTotal, contractorControl, index) => {
      return grandTotal + contractorControl.get('total')?.value;
    }, 0);
  }

  getnonUKCostTotal():number{
    return this.subContractor.controls.reduce((grandTotal, contractorControl, index) => {
      return grandTotal + contractorControl.get('totalForNonUK')?.value;
    }, 0);
  }

  getRndEligibilitySum(contractorIndex: number): number {
    const projectDetails = this.getProjectDetails(contractorIndex).controls;
    let sum = 0;
    projectDetails.forEach((project: any) => {
      const rndEligibility = project.get('rndEligibility').value ? project.get('rndEligibility').value : 0;
      sum += rndEligibility ? parseFloat(rndEligibility) : 0;
    });
    return sum;
  }
  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  exportList(): void {
    const isValid = this.validationService.validateCompanyAndYear(
      this.companyId,
      this.claimYearId
    );
    if (!isValid) {
      return;
    }
    const companyIdStr = this.companyId !== null ? String(this.companyId) : '';
    const yearIdStr = this.claimYearId !== null ? String(this.claimYearId) : '';
    let obj = {
      CompanyId: companyIdStr,
      ClaimYearId: yearIdStr,
    };
    let api = this.api.apiUrl.SubContractorConnectedResource.subContractorConnectedExportForCostCategory;
    this.commonService.doDownloadPost(api, obj).subscribe(
      (response: HttpResponse<Blob>) => {
        const blob = response.body as Blob;
        const link = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = "Contracted Out R&D - Connected - Qualifying Expenditure by Cost Category.xlsx";

        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      },
      (error: any) => {
        console.log(error);
      }
    );
  }
}
